import React from "react";
import { Box } from "@mui/material";
import HeroHub from "./HeroHub";
import HeroValueCards from "./HeroValueCards";

const HeroVisual: React.FC = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1fr) 215px" },
        alignItems: "center",
        columnGap: { md: 4, lg: 5 },
        rowGap: 2,
        width: "100%",
      }}
    >
      <HeroHub />
      <HeroValueCards />
    </Box>
  );
};

export default HeroVisual;
